// hvacAssessmentDataHindi.js

export const allSets = {
  1: [
    { id: "q1", label: "ऊर्जा निगरानी और ट्रैकिंग लागू है", pillar: "ऊर्जा दक्षता" },
    { id: "q2", label: "नियमित HVAC रखरखाव अनुसूचियां पालन की जाती हैं", pillar: "रखरखाव" },
    { id: "q3", label: "आंतरिक वायु गुणवत्ता नियमित रूप से मॉनिटर की जाती है", pillar: "IAQ" },
    { id: "q4", label: "सततता नीतियां दस्तावेजीकृत हैं", pillar: "नीतियां" },
    { id: "q5", label: "HVAC अनुकूलन के लिए स्वचालन का उपयोग किया जाता है", pillar: "स्वचालन" },
  ],
  2: [
    { id: "q1", label: "ऊर्जा-कुशल उपकरण का उपयोग", pillar: "ऊर्जा दक्षता" },
    { id: "q2", label: "निवारक रखरखाव कार्यक्रम मौजूद हैं", pillar: "रखरखाव" },
    { id: "q3", label: "एयर फ़िल्टर अनुसूची के अनुसार बदले जाते हैं", pillar: "IAQ" },
    { id: "q4", label: "पर्यावरणीय अनुपालन सुनिश्चित है", pillar: "नीतियां" },
  ],
  3: [
    { id: "q1", label: "रीयल-टाइम ऊर्जा डैशबोर्ड उपलब्ध", pillar: "ऊर्जा दक्षता" },
    { id: "q2", label: "पूर्वानुमानित रखरखाव प्रणाली लागू", pillar: "रखरखाव" },
    { id: "q3", label: "वायु गुणवत्ता चेतावनी और अलार्म लागू", pillar: "IAQ" },
    { id: "q4", label: "कर्मचारी सततता प्रथाओं में प्रशिक्षित", pillar: "नीतियां" },
    { id: "q5", label: "स्वचालित डिमांड नियंत्रण वेंटिलेशन उपयोग किया गया", pillar: "स्वचालन" },
  ],
  4: [
    { id: "q1", label: "आवश्यकता के अनुसार HVAC अनुकूलन", pillar: "स्वचालन" },
    { id: "q2", label: "नियमित ऊर्जा ऑडिट किए जाते हैं", pillar: "ऊर्जा दक्षता" },
    { id: "q3", label: "रखरखाव लॉग और रिपोर्ट स्वचालित", pillar: "रखरखाव" },
    { id: "q4", label: "ग्रीन सर्टिफिकेशन हासिल किया गया", pillar: "नीतियां" },
  ],
  5: [
    { id: "q1", label: "AI ऊर्जा अपव्यय की भविष्यवाणी करता है और घटाता है", pillar: "ऊर्जा दक्षता" },
    { id: "q2", label: "पूर्वानुमानित रखरखाव पूरी तरह से एकीकृत", pillar: "रखरखाव" },
    { id: "q3", label: "रीयल-टाइम IAQ अनुकूलन", pillar: "IAQ" },
    { id: "q4", label: "संगठन सततता में अग्रणी", pillar: "नीतियां" },
    { id: "q5", label: "पूर्ण स्वचालन और अनुकूलन सक्रिय", pillar: "स्वचालन" },
  ],
};

export const hvacExtras = [
  { id: "e1", label: "HVAC सिस्टम वैरिएबल स्पीड ड्राइव का उपयोग करते हैं", pillar: "ऊर्जा दक्षता" },
  { id: "e2", label: "कूलिंग टॉवर्स की दक्षता मॉनिटर की जाती है", pillar: "ऊर्जा दक्षता" },
  { id: "e3", label: "नियमित कॉइल सफाई और जाँच की जाती है", pillar: "रखरखाव" },
  { id: "e4", label: "IAQ के लिए उन्नत फ़िल्ट्रेशन", pillar: "IAQ" },
  { id: "e5", label: "AI आधारित पूर्वानुमानित अनुसूची लागू", pillar: "स्वचालन" },
];
